/*
 * File: cell-string.ts
 * File Created: 2023-12-18 04:51:11
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-24 07:40:58
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "../../../core/lib/base-table-body-cell/base-table-body-cell";
import { UITag } from "@root/core/tags";

@Component
@UITag.setDefault({
    uiSort: true,
    uiSearch: true,
    uiAlign: "r",
})
export default class CellNumber extends BaseTableBodyCell {}
